import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, from, fromEvent, timer} from 'rxjs';
import { mergeMap, throttleTime, filter, map} from 'rxjs/operators';
import * as moment from 'moment';
import {Router} from "@angular/router";
import Swal from "sweetalert2";

@Injectable({
  providedIn: 'root',
})
export class LastActiveService {

  private inactivityLogoutTimeoutS: number = 1800; // le temps d'inactivité en seconde
  private timerTickMs: number = 500;
  public localStorageKey: string = '__loggedIn';

  public loggedIn: BehaviorSubject<boolean>;
  public loggedIn$: Observable<boolean>;

  private recordTimeoutMs: number = 500;
  private localStorageKeyActive: string = '__lastActive';
  private events: string[] = ['keydown', 'click', 'wheel', 'mousemove'];

  private lastActive: BehaviorSubject<Date>;
  public lastActive$: Observable<Date>;

  constructor(private _router: Router) {
    const lastActiveDate = this.getLastActiveFromLocalStorage() ?? new Date();
    this.lastActive = new BehaviorSubject<Date>(lastActiveDate);
    this.lastActive$ = this.lastActive.asObservable();

    this.loggedIn = new BehaviorSubject(
        this.getLoggedInFromLocalStorage() ?? false
    );
    this.loggedIn$ = this.loggedIn.asObservable();
  }

  counter: number = 0;
  public setUpActivity() {
    timer(0, this.timerTickMs)
        .pipe(filter(_ => this.loggedIn.value))
        .subscribe(_ => {
          const currentDate = moment(new Date());
          const lastActiveDate = this.getLastActiveDate();
          if (moment.duration(currentDate.diff(lastActiveDate)).asSeconds() > this.inactivityLogoutTimeoutS &&
              this.counter === 0) {
              this.counter = 1;
              this.showLogoutAlert();
          }
        });

    fromEvent<StorageEvent>(window, 'storage')
        .pipe(
            filter(event => event.storageArea === localStorage
                && event.key === this.localStorageKey),
            map(event => !!event.newValue)
        )
        .subscribe(loggedIn => {
          this.loggedIn.next(loggedIn);
        });
  }


  public setUp() {

    from(this.events).pipe(mergeMap(event => fromEvent(document, event)), throttleTime(this.recordTimeoutMs)).subscribe(_ => this.recordLastActiveDate());

    fromEvent<StorageEvent>(window, 'storage')
        .pipe(
            filter(event => event.storageArea === localStorage
                && event.key === this.localStorageKeyActive
                && !!event.newValue),
            map(event => new Date(event.newValue!))
        )
        .subscribe(newDate => this.lastActive.next(newDate));
  }

  public getLastActiveDate(): Date {
    return this.lastActive.value;
  }

  private recordLastActiveDate() {
    var currentDate = new Date();
    localStorage.setItem(this.localStorageKeyActive, currentDate.toString());
    this.lastActive.next(currentDate);
  }

  private getLastActiveFromLocalStorage(): Date | null {
    const valueFromStorage = localStorage.getItem(this.localStorageKeyActive);
    if (!valueFromStorage) {
      return null;
    }

    return new Date(valueFromStorage);
  }

  private getLoggedInFromLocalStorage(): boolean | null {
    const valueFromStorage = localStorage.getItem(this.localStorageKey);
    if (!valueFromStorage) {
      return null;
    }

    return !!valueFromStorage;
  }

  private showLogoutAlert() {
    Swal.fire({
      title: 'Inactivité!',
      html: '<p><h3>Vous serez deconnecté dans <b>20 secondes</b></h3></p>',
      icon: 'error',
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: "Je suis là 😊",
      customClass: {
        cancelButton: 'btn btn-success'
      },
      timer: 20000, // temps d'attente avant la deconnexion : milliseconde donc 1s = 1000 secondes
      timerProgressBar: true
    }).then((result) => {

      /* deconnexion apres l'ecoulement du temps */
      if (result.dismiss === Swal.DismissReason.timer) {
        this.logOut();
      }

      /* fermetture du modal */
      if (result.dismiss === Swal.DismissReason.cancel) {
        this.counter = 0;
      }
    })
  }

  private logOut() {
    sessionStorage.clear();
    localStorage.removeItem(this.localStorageKey);
    this.loggedIn.next(false);
    this._router.navigate(['/pages/authentication/login']);
  }
}
